import { FaRegUser } from "react-icons/fa6";
import { FiHome, FiTruck } from "react-icons/fi";
import { MdOutlineShoppingBag } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { AiOutlineLogin } from "react-icons/ai";
import { useSelector } from "react-redux";

function BottomNav() {
  const customer = localStorage.getItem("rms-customer");
  const cart = useSelector((state) => state.products.cart);

  return (
    <nav className="flex items-center justify-between py-3 px-5 fixed bottom-0 left-0 z-20 w-full bg-white lg:hidden border-t">
      <NavLink
        to="/"
        className="active router-link-exact-active text-primary flex flex-col items-center gap-1"
        aria-current="page"
      >
        <FiHome className="text-xl" />
        <span className="text-xs capitalize">Home</span>
      </NavLink>
      <NavLink
        to={"mycart"}
        className="active router-link-exact-active text-primary flex flex-col items-center gap-1 relative"
      >
        {cart.length > 0 && (
          <span className="bg-w-btn text-w-btn-text border border-w-border rounded-full text-xs absolute -top-2 -right-2 size-4 text-center">
            {cart.length}
          </span>
        )}
        <MdOutlineShoppingBag className="text-xl" />
        <span className="text-xs capitalize">Cart</span>
      </NavLink>
      <NavLink href="#/offers" className="flex flex-col items-center gap-1">
        <FiTruck className="text-xl" />
        <span className="text-xs capitalize">Track Order</span>
      </NavLink>
      {customer ? (
        <NavLink to="/dashboard" className="flex flex-col items-center gap-1">
          <FaRegUser className="text-xl" />
          <span className="text-xs capitalize">My Account</span>
        </NavLink>
      ) : (
        <NavLink to={"login"} className="flex flex-col items-center gap-1">
          <AiOutlineLogin className="text-xl" />
          <span className="text-xs capitalize">Login</span>
        </NavLink>
      )}
    </nav>
  );
}

export default BottomNav;
